import { jwtDecode as jwt } from "jwt-decode";

export class AuthenticationFunctions {
  public static getTokenDataByKey = (key: string): any => {
    const storage = localStorage.getItem("LOGIN_INFO");
    if (storage) {
      const objStorage = JSON.parse(storage);
      const token = objStorage.accessToken;
      const tokenDecode: { [x: string]: any } = jwt(token);
      if (tokenDecode[key]) {
        return tokenDecode[key];
      }
    }
    return null;
  };
}
